import { render, staticRenderFns } from "./SocialWallPostPreview.vue?vue&type=template&id=0e00f660&scoped=true"
import script from "./SocialWallPostPreview.vue?vue&type=script&lang=js"
export * from "./SocialWallPostPreview.vue?vue&type=script&lang=js"
import style0 from "./SocialWallPostPreview.vue?vue&type=style&index=0&id=0e00f660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e00f660",
  null
  
)

export default component.exports